import * as React from 'react';
import { Box, BoxProps } from '.';
import { getPosition } from '../../utils/layout';

export interface AbsoluteProps extends BoxProps {
    anchor?: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'fill' | 'fill-x' | 'fill-y'
}

const Absolute: React.FC<AbsoluteProps> = React.forwardRef((props: AbsoluteProps, ref: React.ElementRef<any>) => {
    const adjustedProps = { ...props };
    if (adjustedProps.anchor) {
        const pos = getPosition(adjustedProps.anchor);
        Object.keys(pos).forEach((key) => { adjustedProps[key] = pos[key]; });
        delete adjustedProps.anchor;
    }
    return <Box position="absolute" ref={ref} {...adjustedProps} />;
});

export default Absolute;
